import React from "react";
import { DashboardMenuItem, Logout, useResourceDefinitions, useSidebarState } from "react-admin"; // 変更箇所

import { useMediaQuery } from "@mui/material";

import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import List from "@mui/material/List";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SettingsIcon from "@mui/icons-material/Settings";

import { MyMenuItem, SubMenu } from "./MyMenuItem";
import { TermsIcon } from "../svg/TermsIcon";
import { UsageIcon } from "../svg/UsageIcon";
import { STATIC_FILE_BASE_URL } from "../config/constConfig";

const CONTRACT_GUIDE_FILE_PATH = "/buyer/contract_guide.pdf";
const DELIVERY_GUIDE_FILE_PATH = "/buyer/delivery_guide.pdf";
const mobilePrototypeResources = ["pending_tasks", "deals"];

const commonStyles = {
  openInNewIcon: {
    fontSize: "16px",
    marginTop: "6px",
    marginLeft: "4px",
  },
};

export const MyMenu = (props: any) => {
  const { onMenuClick } = props;
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
  const [open] = useSidebarState();
  const resources = useResourceDefinitions();
  // resources オブジェクトを配列に変換
  const resourceArray = Object.keys(resources).map((key) => ({
    name: key,
    ...resources[key],
  }));

  const spotContractLists = [
    "spot_contract_offers",
    "spot_contract_others_offers",
    "spot_contract_deals",
    "spot_contract_payments",
  ];
  const transactionLists = [
    "pending_tasks",
    "offers",
    "others_offers",
    "adjustment_deals",
    "deals",
    "payments",
    "offer_requests",
    "producer_summaries",
  ];
  const customRouteLists = ["wholesaler_setting_mail_notification"];
  const borderTopName = "offer_requests";
  const borderBottomName = "producer_summaries";
  const transactions = resourceArray.filter((r: any) => transactionLists.includes(r.name));
  const masters = resourceArray.filter(
    (r: any) =>
      (!transactionLists.includes(r.name) && !spotContractLists.includes(r.name) && r.hasList) ||
      customRouteLists.includes(r.name)
  );
  const menuResources = isMobile
    ? resourceArray.filter((resource: any) => mobilePrototypeResources.includes(resource.name))
    : transactions;

  return (
    <>
      <List component="div" disablePadding>
        <DashboardMenuItem />
        {menuResources.map((res: any) => {
          return (
            <MyMenuItem
              key={res.name}
              onMenuClick={onMenuClick}
              resource={res}
              sidebarOpen={open}
              inSubMenu={false}
              isBorderBottom={!isMobile && res.name === borderBottomName}
              isBorderTop={!isMobile && res.name === borderTopName}
            />
          );
        })}
        {!isMobile && (
          <SubMenu
            primaryText={"設定"}
            resources={masters}
            sidebarOpen={open}
            onMenuClick={onMenuClick}
            icon={SettingsIcon}
          />
        )}
      </List>
      {isMobile && <Logout />}
      {!isMobile && (
        <>
          <Box ml={2} mt={4}>
            <Link href={STATIC_FILE_BASE_URL + CONTRACT_GUIDE_FILE_PATH} target="_blank">
              <Box display="flex" flexDirection="row">
                {!open ? (
                  <UsageIcon />
                ) : (
                  <>
                    <Box mr={1}>
                      <UsageIcon />
                    </Box>
                    <Box>成約マニュアル</Box>
                    <OpenInNewIcon sx={commonStyles.openInNewIcon} />
                  </>
                )}
              </Box>
            </Link>
          </Box>
          <Box ml={2} mt={2}>
            <Link href={STATIC_FILE_BASE_URL + DELIVERY_GUIDE_FILE_PATH} target="_blank">
              <Box display="flex" flexDirection="row">
                {!open ? (
                  <UsageIcon />
                ) : (
                  <>
                    <Box mr={1}>
                      <UsageIcon />
                    </Box>
                    <Box>受渡マニュアル</Box>
                    <OpenInNewIcon sx={commonStyles.openInNewIcon} />
                  </>
                )}
              </Box>
            </Link>
          </Box>
          <Box ml={2} mt={2}>
            <Link href="/terms/terms4b.pdf" target="_blank">
              <Box display="flex" flexDirection="row">
                {!open ? (
                  <TermsIcon />
                ) : (
                  <>
                    <Box mr={1}>
                      <TermsIcon />
                    </Box>
                    <Box>利用規約</Box>
                    <OpenInNewIcon sx={commonStyles.openInNewIcon} />
                  </>
                )}
              </Box>
            </Link>
          </Box>
        </>
      )}
    </>
  );
};
